import { Controller } from "@hotwired/stimulus"
import { createPopper } from "@popperjs/core"
// import { useClickOutside, useIntersection, useTransition } from 'stimulus-use'
import { useTransition } from "stimulus-use"
import { dispatchCustomEvent } from "../src/index"
// import { IntersectionController } from 'stimulus-use'
// import { useTransition } from 'stimulus-use/dist/use-transition'

/* przykład użycia: app/views/design/uix/stimulus.html.erb */

export default class extends Controller {
  static targets = ["menu", "input", "list"]
  static values = { loaded: Boolean, position: String, overlay: Boolean, offset: Number }

  eventCreated = false
  dropdownOpen = false
  menuHidden = false
  transitionUsed = false

  connect() {
    console.log("intum - dropdown_controller#connect")
    if (this.hasMenuTarget) {
      // tryb overlay (natywny popover w top-layer) - pokazywanie/chowanie robimy przez showPopover,
      // bez useTransition i bez Poppera; pozycjonuje positionOverlay. Reszta zachowań bez zmian.
      if (this.useOverlay) {
        this.menuHidden = true
        return
      }

      if (this.menuTarget.classList.contains("hidden")) {
        // this.menuTarget.classList.add('hidden')
        this.menuHidden = true
        useTransition(this, { element: this.menuTarget })
      }

      if (this.hasPositionValue) {
        console.log("hasPositionValue", this.positionValue)
        const modifiers = [
          {
            name: "flip",
            options: {
              fallbackPlacements: ["top", "bottom", "left", "right"],
            },
          },
          {
            name: "preventOverflow",
            options: {
              boundary: "viewport",
            },
          },
        ]
        // opcjonalny odstęp menu od przycisku wzdłuż osi placement (dla bottom-* przesuwa menu niżej)
        if (this.hasOffsetValue) {
          modifiers.push({ name: "offset", options: { offset: [0, this.offsetValue] } })
        }
        this.popper = createPopper(this.element, this.menuTarget, {
          placement: this.positionValue,
          strategy: "fixed",
          modifiers,
        })
        console.log("poper", this.popper)
      }
    }
  }

  search() {
    let button, i, txtValue
    const input = this.inputTarget
    const filter = input.value.toUpperCase()
    const ul = this.listTarget
    const li = ul.getElementsByTagName("li")

    for (i = 0; i < li.length; i++) {
      button = li[i].getElementsByTagName("button")[0] || li[i].getElementsByTagName("a")[0]
      // przypadek wyszukiwania userów - napisy ostatnio wybierani/zespół/wszyscy nie są linkami i wywalały funkcję
      if (button !== undefined) {
        txtValue = button.textContent || button.innerText
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          li[i].style.display = ""
        } else {
          li[i].style.display = "none"
        }
      }
    }
    dispatchCustomEvent(this.element, "dropdown:search", { input: input.value })
  }

  toggle() {
    if (this.useOverlay) {
      this.toggleOverlay()
      return
    }
    console.log("toggle1")
    console.log(this.menuTarget.classList.contains("hidden"))
    console.log(this.menuHidden)
    if (this.menuHidden) {
      this.toggleTransition()
    } else {
      this.menuHidden = true
      useTransition(this, { element: this.menuTarget })
    }

    // jeśli chcemy by przycisk się obracał po kliknięciu to dodajemy do svg klasę "intum-rotate"
    const rotatedButton = this.element.querySelector("svg.intum-rotate-90")
    if (rotatedButton) {
      rotatedButton.classList.toggle("rotate-90")
    }

    // jeśli chcemy by przycisk się obracał po kliknięciu to dodajemy do svg klasę "intum-rotate"
    const rotatedButton180 = this.element.querySelector("svg.intum-rotate-180")
    if (rotatedButton180) {
      rotatedButton180.classList.toggle("rotate-180")
    }

    if (this.popper) { this.popper.update() }
    if (this.hasNavigationTarget) {
      this.navigationTarget.classList.remove("hidden")
    }
    if (this.hasSubContainerTarget) {
      this.subContainerTarget.classList.add("shadow-md")
    }
    // https://discuss.hotwired.dev/t/add-and-remove-eventlisteners/710
    if (this.eventCreated === false) {
      const fn = this.outsideHide.bind(this)
      this.eventCreated = fn
      this.dropdownOpen = true
      console.log("eventCreated1")
      if (this.hasInputTarget) { this.inputTarget.focus() }
      document.addEventListener("click", fn)
    } else {
      this.removeEvent()
    }
  }

  open() {
    if (this.useOverlay) {
      this.openOverlay()
      return
    }
    console.log("open1")
    this.toggleTransition()
    if (this.popper) { this.popper.update() }
  }

  // overlay tylko gdy: włączony, menu ma atrybut popover ORAZ przeglądarka wspiera Popover API.
  // hasAttribute("popover") chroni przed showPopover() na elemencie bez atrybutu (rzuca wyjątek);
  // starsze przeglądarki (np. iOS < 17) bez showPopover lecą zwykłym dropdownem (useTransition/Popper)
  get useOverlay() {
    return this.overlayValue && this.hasMenuTarget &&
      this.menuTarget.hasAttribute("popover") && typeof this.menuTarget.showPopover === "function"
  }

  toggleOverlay() {
    if (this.menuTarget.matches(":popover-open")) {
      this.closeOverlay()
    } else {
      this.openOverlay()
    }
  }

  // pokazanie listy jako natywny popover (top-layer) - nieprzycinane przez overflow przodka.
  // Dokłada nasłuch scroll/resize (reposition) i IntersectionObserver (chowanie gdy trigger zjedzie z widoku).
  openOverlay() {
    this.menuTarget.classList.remove("hidden")
    if (!this.menuTarget.matches(":popover-open")) { this.menuTarget.showPopover() }
    this.menuTarget.style.visibility = "visible"
    this.positionOverlay()
    this.repositionHandler = this.repositionHandler || this.positionOverlay.bind(this)
    window.addEventListener("scroll", this.repositionHandler, true)
    window.addEventListener("resize", this.repositionHandler)
    this.observeTriggerVisibility()
    // zamykanie klikiem poza (ten sam mechanizm co reszta dropdowna)
    if (this.eventCreated === false) {
      this.eventCreated = this.outsideHide.bind(this)
      document.addEventListener("click", this.eventCreated)
    }
  }

  // ukrycie listy (odwrotność openOverlay) - sprzątamy nasłuchy i observer
  closeOverlay() {
    if (this.repositionHandler) {
      window.removeEventListener("scroll", this.repositionHandler, true)
      window.removeEventListener("resize", this.repositionHandler)
    }
    if (this.visibilityObserver) { this.visibilityObserver.disconnect() }
    if (this.menuTarget.matches(":popover-open")) { this.menuTarget.hidePopover() }
    this.menuTarget.classList.add("hidden")
    this.removeEvent()
  }

  // IntersectionObserver liczy widoczność triggera z uwzględnieniem przycięcia przez pośrednie
  // kontenery z overflow (box zadań) - gdy trigger zniknie, chowamy listę; gdy wraca - pokazujemy i repozycjonujemy
  observeTriggerVisibility() {
    if (this.visibilityObserver) { this.visibilityObserver.disconnect() }
    this.visibilityObserver = new IntersectionObserver((entries) => {
      const visible = entries[0].isIntersecting
      this.menuTarget.style.visibility = visible ? "visible" : "hidden"
      if (visible) { this.positionOverlay() }
    }, { threshold: 0 })
    this.visibilityObserver.observe(this.element)
  }

  // pozycjonuje popover (fixed) względem triggera; kierunek z position (left/force_left/bottom-start = od lewej
  // krawędzi, inaczej od prawej), flip w górę gdy nie mieści się na dole
  positionOverlay() {
    const trigger = this.element.getBoundingClientRect()
    const panel = this.menuTarget
    panel.style.margin = "0"
    panel.style.inset = "auto"
    panel.style.position = "fixed"
    const rect = panel.getBoundingClientRect()
    const alignLeft = !/right|end/.test(this.positionValue || "")
    let left = alignLeft ? trigger.left : trigger.right - rect.width
    let top = trigger.bottom + 4
    if (top + rect.height > window.innerHeight - 8) { top = trigger.top - rect.height - 4 }
    if (left < 8) { left = 8 }
    if (left + rect.width > window.innerWidth - 8) { left = window.innerWidth - rect.width - 8 }
    panel.style.left = `${left}px`
    panel.style.top = `${top}px`
  }

  hide(event) {
    // console.log('hide1', this.element, event.target)
    console.log("hide1", event)
    this.leave()
    this.removeEvent()
  }

  outsideHide(event) {
    console.log("outsideHide1", event)
    // tryb overlay: menu jest w top-layer (nie ma klasy hidden), więc sprawdzamy zawieranie w triggerze i menu
    if (this.useOverlay) {
      if (!this.element.contains(event.target) && !this.menuTarget.contains(event.target)) {
        this.closeOverlay()
      }
      return
    }
    // this.hide(event)
    if (!this.element.contains(event.target) && !this.menuTarget.classList.contains("hidden")) {
      this.leave()
      this.removeEvent()
      // jeśli chcemy by przycisk się obracał po kliknięciu to dodajemy do svg klasę "intum-rotate"
      const rotatedButton = this.element.querySelector("svg.intum-rotate-90")
      if (rotatedButton) {
        rotatedButton.classList.toggle("rotate-90")
      }

      // jeśli chcemy by przycisk się obracał po kliknięciu to dodajemy do svg klasę "intum-rotate"
      const rotatedButton180 = this.element.querySelector("svg.intum-rotate-180")
      if (rotatedButton180) {
        rotatedButton180.classList.toggle("rotate-180")
      }
    }
  }

  removeEvent() {
    if (this.eventCreated !== false) {
      this.dropdownOpen = false
      if (this.hasNavigationTarget) {
        this.navigationTarget.classList.add("hidden")
      }
      if (this.hasSubContainerTarget) {
        this.subContainerTarget.classList.remove("shadow-md")
      }
      console.log("removeEvent1")
      document.removeEventListener("click", this.eventCreated)
      this.eventCreated = false
    }
  }

  fillDropdown(event) {
    // select_id powinien miec format "new_ID_SELECTA_Z_FORMULARZA", wtedy tym dropdownem mozemy wypelnic wlasciwy select w formularzu
    let selectId = event.params.select
    const headerDiv = document.getElementById(selectId + "_name")
    const headerLink = headerDiv.querySelector("a")
    const modelUrl = event.params.url
    let chosenId = parseInt(event.params.id)
    chosenId = !Number.isInteger(chosenId) ? "" : chosenId
    selectId = selectId.split("new_")[1]
    const selectElement = document.getElementById(selectId)

    if (headerLink !== null) {
      headerLink.href = `${modelUrl}/${chosenId}`
      headerLink.text = event.target.text.trim()
    } else {
      // przypadek gdy wartością początkową było 'none'
      const newLink = document.createElement("a")
      newLink.setAttribute("href", `${modelUrl}/${chosenId}`)
      newLink.text = event.target.text.trim()
      headerDiv.innerHTML = ""
      headerDiv.appendChild(newLink)
    }
    selectElement.value = chosenId
    this.toggle()
  }

  // Kopiuje link do schowka. Używa Clipboard API gdy dostępne (HTTPS/localhost),
  // a w nie-secure context (HTTP, np. lokalnie *.intum.test) korzysta z fallbacku.
  copyLink(event) {
    const copyText = event.params.link
    const id = event.params.id

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(copyText)
        .then(() => this.showCopied(id))
        .catch(() => this.fallbackCopy(copyText, id))
    } else {
      this.fallbackCopy(copyText, id)
    }
  }

  // Fallback kopiowania dla nie-secure context - ukryty textarea + execCommand.
  fallbackCopy(text, id) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()

    try {
      if (document.execCommand("copy")) this.showCopied(id)
    } catch (err) {
      console.error("Nie udało się skopiować linku:", err)
    } finally {
      document.body.removeChild(textarea)
    }
  }

  // Pokazuje chwilowo stan "skopiowano" - przełącza przyciski copy/copied po id.
  showCopied(id) {
    if (!id) return

    const index = id.lastIndexOf("_")
    const prefix = id.slice(0, index)
    const copiedId = prefix + "_copied"
    const button = document.getElementById(id)
    const buttonCopied = document.getElementById(copiedId)
    if (!button || !buttonCopied) return

    button.classList.add("hidden")
    buttonCopied.classList.remove("hidden")

    setTimeout(() => {
      button.classList.remove("hidden")
      buttonCopied.classList.add("hidden")
    }, 1000)
  }

  toTextInput(event) {
    const selectInput = this.listTarget
    if (selectInput.value !== "more") {
      return
    }

    const options = event.params
    const textInput = document.createElement("input")

    textInput.id = options.name
    textInput.name = options.name
    textInput.classList = options.classlist
    textInput.value = options.value

    selectInput.replaceWith(textInput)
    textInput.focus()
  }

  disconnect() {
    this.removeEvent()
    if (this.repositionHandler) {
      window.removeEventListener("scroll", this.repositionHandler, true)
      window.removeEventListener("resize", this.repositionHandler)
    }
    if (this.visibilityObserver) { this.visibilityObserver.disconnect() }
  }
}
